import { render, staticRenderFns } from "./CallOutlined.vue?vue&type=template&id=74196542"
import script from "./CallOutlined.vue?vue&type=script&lang=js"
export * from "./CallOutlined.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports